<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '新建设计师' : '编辑设计师' }}
                </h1>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  @click="submitForm"
                >
                  保存
                </button>
              </div>
            </header>
          </div>
          <main class="resourceFormPage__main main">
            <designer-form-shell
              :rule-form="ruleForm"
              :is-create="isCreate"
              :upload-loading="uploadLoading"
              @avatar-upload="uploadAvatar"
            />
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from '../../../api/comment'
import {
  designerCreate,
  designerUpdate,
  getDesignerById,
} from '../../../api/designerManage'
import DesignerFormShell from './DesignerFormShell.vue'
import {
  applyDesignerDetail,
  buildDesignerPayload,
  emptyDesignerForm,
} from './designerFormModel'

export default {
  name: 'DesignerCreateOrEdit',
  components: { DesignerFormShell },
  data() {
    return {
      ruleForm: emptyDesignerForm(),
      isCreate: true,
      loading: false,
      uploadLoading: false,
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '类型不能为空', trigger: 'change' }],
        backgroundUrl: [{ required: true, message: '头像不能为空', trigger: 'change' }],
        birthday: [{ required: true, message: '生日不能为空', trigger: 'change' }],
      },
    }
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    if (this.isCreate) {
      this.ruleForm.birthday = '2000-01'
    } else {
      this.loadDetail()
    }
  },
  methods: {
    loadDetail() {
      this.loading = true
      getDesignerById({ id: this.$route.params.id })
        .then((res) => {
          if (!res.success) return
          this.ruleForm = applyDesignerDetail(res.data)
          if (this.ruleForm.birthdayPublic === 1) {
            this.rules.birthday = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    uploadAvatar(request) {
      const fileName = request.file.name
      const suffix = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
      if (suffix !== 'jpg' && suffix !== 'png') {
        this.$message.error('请上传 jpg 或 png')
        return
      }
      if (!this.ruleForm.name) {
        this.ruleForm.name = fileName.substring(0, fileName.lastIndexOf('.'))
      }
      const body = new FormData()
      body.append('file', request.file)
      this.uploadLoading = true
      uploadFile(body)
        .then((res) => {
          if (!res.success) return
          this.ruleForm.backgroundUrl = res.data
          this.ruleForm.backgroundName = fileName
        })
        .finally(() => {
          this.uploadLoading = false
        })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.error('还有必填项没有完成')
          return
        }
        const payload = buildDesignerPayload(this.ruleForm)
        const request = this.isCreate ? designerCreate(payload) : designerUpdate(payload)
        request.then((res) => {
          if (!res.success) return
          this.$message.success(this.isCreate ? '新增成功' : '修改成功')
          this.$router.push('/resource/designer/list')
        })
      })
    },
    goBack() {
      this.$router.push('/resource/designer/list')
    },
  },
}
</script>

<style scoped>
.fullContainer {
  width: 100%;
  height: 100%;
}
</style>
